import * as Styled from "./style";
import type { G_VideoCampaign } from "~/lib/graphql";
import { formatDateToYMDDayHm } from "~/util/format-date";

type SaleInfoTagProps = {
  campaign?: Pick<G_VideoCampaign, "endAt" | "name"> | null;
};

/**
 * DMMでの取扱情報タグの「セール情報」の表示の出し分けを行うコンポーネント
 *
 * @機能要件
 * - セール中だった場合 : セールタグを表示すること
 * - セール中でなかった場合 : セールタグを表示しないこと
 */
export const SaleInfoTag = (props: SaleInfoTagProps) => {
  const { campaign } = props;

  if (campaign === undefined || campaign === null) return null;

  const { name, endAt } = campaign;

  if (new Date(endAt).getTime() < Date.now()) return null;

  return (
    <Styled.TagFlexWrapRoot>
      <Styled.SaleTag tagText="セール" bgColor="RED900" subTextColor="RED900" />
      <Styled.ParSaleTagSubText>
        {name} {formatDateToYMDDayHm(endAt)}まで
      </Styled.ParSaleTagSubText>
    </Styled.TagFlexWrapRoot>
  );
};
